const KL_SHARE_SELECTOR = '[data-kl-share]';
const KL_SHARE_FEEDBACK_SELECTOR = '[data-kl-share-feedback]';
const KL_SHARE_FEEDBACK_DURATION = 2400;

function showShareFeedback(feedback, message) {
  if (!feedback) return;

  feedback.textContent = message;
  feedback.classList.add('is-visible');

  clearTimeout(feedback.klShareTimeout);
  feedback.klShareTimeout = setTimeout(() => {
    feedback.classList.remove('is-visible');
    feedback.textContent = '';
  }, KL_SHARE_FEEDBACK_DURATION);
}

function copyShareUrl(url) {
  if (!navigator.clipboard) return Promise.reject(new Error('Clipboard unavailable'));

  return navigator.clipboard.writeText(url);
}

async function handleShareClick(button) {
  if (!button) return;

  const url = document.location.href;
  const title = button.dataset.klShareTitle || document.title;
  const feedback = button.parentElement?.querySelector(KL_SHARE_FEEDBACK_SELECTOR);

  if (navigator.share) {
    try {
      await navigator.share({ title, url });
      return;
    } catch (error) {
      if (error?.name === 'AbortError') return;

      console.debug('kl-share: native share failed, falling back to the clipboard', { url, error });
    }
  }

  try {
    await copyShareUrl(url);
    showShareFeedback(feedback, button.dataset.klShareCopiedLabel || 'Link copied');
  } catch (error) {
    console.debug('kl-share: could not copy the product link', { url, error });
  }
}

document.addEventListener('click', (event) => {
  const button = event.target.closest(KL_SHARE_SELECTOR);

  if (!button) return;

  handleShareClick(button);
});
